export default ($axios) => ({
  fetch(query) {
    return $axios.get(`/whatsapp/new/templates/${query.number}`, { params: query }).then((response) => response.data);
  },
});
